import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import HeaderButton from '@mirinae/wikinae/components/common/header/HeaderButton';
import SearchBlock from '@mirinae/wikinae/components/common/search/SearchBlock';
import Search, { SearchExpand, SearchLayer } from '@mirinae/wikinae/components/common/search/Search';
import { entriesAPI } from '@mirinae/wikinae/modules/apis/entries';
import { UserContext } from '@mirinae/react-auth';

const SearchContainer = ({ theme, query = '', isMobile, onClick, onDetectLayer }) => {
    const location = useLocation();
    const [userContext] = useContext(UserContext);
    const [expand, setExpand] = useState(false);
    const [popular, setPopular] = useState([]);
    const [searchTerms, setSearchTerms] = useState([]);
    const [userTerms, setUserTerms] = useState([]);

    const isGuest = userContext.user.loginType === 'guest';

    useEffect(() => {
        setExpand(false);
    }, []);

    useEffect(() => {
        if (expand) {
            // Recent Search History
            if (!isGuest) {
                entriesAPI.usersearchterms().then(response => {
                    const { success, data } = response;
                    if (success && data) {
                        setUserTerms(data.terms);
                    }
                });
            }

            // What people are searching for
            entriesAPI.searchterms().then(response => {
                const { success, data } = response;
                if (success && data) {
                    setPopular(data.terms);
                }
            });
        }
        if (onDetectLayer) onDetectLayer(expand);
    }, [expand]);

    useEffect(() => {
        setExpand(false);
    }, [location.pathname, location.search]);

    const handleOpen = () => {
        setExpand(true);
    };

    const handleDelete = () => {
        entriesAPI.clearusersearchterms().then(response => {
            if (response.success) {
                setUserTerms([]);
            }
        });
    };

    const handleSelect = (keyword) => {
        if (onClick) onClick(keyword);
        setExpand(false);
    };

    const handleChangeSearchInput = (text) => {
        if (theme !== 'header') return;
        const t = text.replace(/\\|'|"/g, '').trim();
        if (t === '') return;
        entriesAPI.searchterms(t).then(response => {
            const { success, data } = response;
            if (success && data) {
                setSearchTerms(data.terms);
            }
        });
    };

    return (
        <Search theme={theme}>
            {theme === 'header' ? (
                <>
                    {(!location.search || !(new URLSearchParams(window.location.search).has('q'))) && ( // hide search icon on search result page
                        <HeaderButton type="button" onClick={handleOpen} icon="zoom">
                            Open search layer
                        </HeaderButton>
                    )}

                    {expand && (
                        isMobile ? (
                            <SearchLayer onClose={() => setExpand(false)}>
                                <SearchBlock
                                    theme="layer" query={query} searchTerms={searchTerms} userTerms={userTerms} popular={popular}
                                    onChange={handleChangeSearchInput} onClick={handleSelect} onDelete={handleDelete} />
                            </SearchLayer>
                        ) : (
                            <SearchExpand>
                                <HeaderButton type="button" onClick={() => setExpand(false)}>
                                    Close search layer
                                </HeaderButton>

                                <SearchBlock
                                    theme={theme} query={query} searchTerms={searchTerms} userTerms={userTerms} popular={popular}
                                    onChange={handleChangeSearchInput} onClick={handleSelect} onDelete={handleDelete} />
                            </SearchExpand>
                        )
                    )}
                </>
            ) : (
                <SearchBlock
                    theme={theme} query={query} searchTerms={searchTerms} userTerms={userTerms} popular={popular}
                    onChange={handleChangeSearchInput} onClick={handleSelect} onDelete={handleDelete} />
            )}
        </Search>
    );
};

export default SearchContainer;
